var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAreYouSure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 75C58.7107 75 75.5 58.2107 75.5 37.5C75.5 16.7893 58.7107 0 38 0C17.2893 0 0.5 16.7893 0.5 37.5C0.5 58.2107 17.2893 75 38 75Z",
    fill: "#273B49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.7714 48.9268L42.0826 12.2689C40.9608 10.4843 39.3902 9.5177 37.8944 9.5177C36.3986 9.5177 34.9029 10.41 33.7062 12.2689L12.0175 48.9268C9.69904 52.5702 11.3444 55.7676 15.6821 55.7676H60.1067C64.4445 55.7676 66.0898 52.4959 63.7714 48.9268Z",
    fill: "#FDDA21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8944 49.0754C39.1336 49.0754 40.1381 48.0767 40.1381 46.8447C40.1381 45.6127 39.1336 44.614 37.8944 44.614C36.6553 44.614 35.6508 45.6127 35.6508 46.8447C35.6508 48.0767 36.6553 49.0754 37.8944 49.0754Z",
    fill: "#273B49"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8196 41.1937C38.4179 41.268 38.9414 40.7475 39.0162 40.1527L39.9885 26.7685C39.9885 26.6941 39.9885 26.5454 39.9885 26.471C39.9137 25.2813 38.8667 24.4634 37.7448 24.5378C36.623 24.6121 35.7255 25.6531 35.8003 26.7685L36.7726 40.1527C36.7726 40.6732 37.2213 41.1193 37.8196 41.1937Z",
    fill: "#273B49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreYouSure);
export default __webpack_public_path__ + "static/media/are-you-sure.50ad10b8b66bfee82f00471979b97772.svg";
export { ForwardRef as ReactComponent };